import React from 'react';
import { Dialog, DialogContent, Box, Typography, IconButton, Rating } from '@mui/material';
import Iconify from './Iconify'; // Make sure to adjust the path to your Iconify component.

const ShiperProfileComponent = ({ open, onClose, companyData }) => {
  return (
    <Dialog
      sx={{ padding: 0, boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)' }}
      open={open}
      onClose={onClose}
    >
      <DialogContent style={{ padding: 0 }}>
        <Box
          sx={{
            width: '320px',
            margin: 'auto',
            borderRadius: '5px',
            overflow: 'hidden',
            boxShadow: 3,
            backgroundColor: 'white',
            fontFamily: 'Arial, sans-serif'
          }}
        >
          {/* Header Section */}
          <Box
            sx={{
              backgroundColor: '#010f58',
              color: 'white',
              height: 60,
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-end'
            }}
          >
            <IconButton onClick={onClose}>
              <Iconify icon="ic:round-clear" style={{ fontSize: 19, color: '#fff' }} />
            </IconButton>
          </Box>

          {/* Profile Section */}
          <Box
            sx={{
              backgroundColor: '#010f58',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              height: 30
            }}
          >
            <Box
              sx={{
                width: '100px',
                height: '100px',
                borderRadius: '50%',
                background: 'white',
                overflow: 'hidden',
                border: '4px solid #fff',
                boxShadow: 2,
                position: 'absolute',
                top: -20
              }}
            >
              <img
                src={companyData?.avatar}
                alt={companyData?.company}
                style={{ width: '100%', height: '100%' }}
              />
            </Box>
          </Box>

          {/* Name and Role */}
          <Box sx={{ textAlign: 'center', padding: 2, marginTop: 5 }}>
            <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 'bold' }}>
              {companyData?.company}
            </Typography>
            <Typography
              sx={{
                fontSize: '12px',
                textTransform: 'capitalize',
                flex: 1,
                textAlign: 'center',
                marginTop: -0.5
              }}
            >
              {companyData?.role?.role_name}
            </Typography>
          </Box>

          {/* Details Section */}
          <Box sx={{ paddingX: 2, paddingBottom: 2 }}>
            {[
              { label: 'Total Score', value: companyData?.total_score },
              { label: 'Success Score', value: companyData?.success_score },
              { label: 'Cancel Score', value: companyData?.cancel_score },
              { label: 'Total Spending', value: companyData?.total_spending }
            ].map((item) => (
              <Box
                key={item.label}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '8px'
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: 'grey',
                    fontSize: '13px'
                  }}
                >
                  {item.label} :
                </Typography>
                {item.label === 'Rating' ? (
                  <Typography
                    sx={{ fontSize: 15, marginBottom: -0.8, textAlign: 'right', flex: 1 }}
                  >
                    <Rating size="small" name="read-only" value={item.value} readOnly />
                  </Typography>
                ) : (
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: '14px',
                      textAlign: 'right',
                      flex: 1
                    }}
                  >
                    {item.value}
                  </Typography>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ShiperProfileComponent;
